export default {
  countryZones: [],
  activeCountryZone: null,
  activeInCountryZone: null,
  inCountryZones: [],
  isZoneManagerPanelOpen: true,
  currentDivision: null,
  /** Live search for both zone tables (API where[name], see query-builder.php) */
  zoneNameSearch: '',
}
